import { ContactsDirectory } from "../modules/contactsDirectory";

export const ContactsDirectoryPage = () => {
  return <ContactsDirectory />;
};
